import { BaanRueJaiClient } from "./clients/BaanRueJaiClient";
import { HTTPClient } from "./clients/HTTPClient";
import { ArticleUseCase } from "./features/articles/ArticleUseCase";
import { BackendAdminClient } from "./clients/BackendAdminClient";
import { getCookie, Auth } from "./lib/cookie";

const baseURL = process.env.HOST;
const httpClient = new HTTPClient(baseURL);
export const baanRueJaiClient = new BaanRueJaiClient(httpClient);

// Get token from localStorage
let token = localStorage.getItem("accessToken");

// Get token from cookie
const accessToken = getCookie(Auth.AccessToken);

// Set token
if (accessToken) {
  token = accessToken;
}

baanRueJaiClient.setAuthorizationToken(token);

export const articleUseCase = new ArticleUseCase(baanRueJaiClient);

// Setup backend admin client
export const backendAdminClient = new BackendAdminClient()
